














































































































































































































































































































































































































































































































































































































































































  import Vue from 'vue'
  import { mapState } from 'vuex'
  import { stockStatuses } from '@/formHelpers'
  import { ApiResponse, Rate, Sale, Contact } from '@/interfaces'
  import AbbreviationsMixin from '@/mixins/abbreviationsMixin'

  interface Rubrique {
    children?: Rubrique
    label: string
    value: null | string
  }

  export default Vue.extend({
    mixins: [AbbreviationsMixin],
    props: {
      items: {
        type: Array,
        required: false,
        default: () => {
          return []
        },
      },
      page: {
        type: String,
        required: false,
        default: null,
      },
      contact: {
        type: String,
        required: false,
        default: null,
      },
      saleId: {
        type: Number,
        required: false,
        default: null,
      },
      query: {
        type: Object,
        required: false,
        default: null,
      },
      editPrice: {
        type: Boolean,
        required: false,
        default: false,
      },
      itemToEdit: {
        type: Object,
        required: false,
        default: null,
      },
      requisitionId: {
        type: Number,
        required: false,
        default: null,
      },
      displayField: {
        type: Boolean,
        required: false,
        default: true,
      },
    },
    data() {
      return {
        busy: false,
        viewportWidth: 0,
        formModel: {
          weaponBook: null as null | string,
          vehicule: null as null | string,
          policeBook: null as null | string,
          adagp: null as null | string,
          rubriqueKey: [null] as unknown,
          highlight: null as null | string,
          sale: null as null | string,
          stockStatus: null as null | string,
          dateIn: null as null | string,
          dateOut: null as null | string,
          itemNumber: null as null | string,
          itemSubNumber: null as null | string,
          estimationLow: null as null | string,
          estimationHigh: null as null | string,
          startingPrice: null as null | string,
          reservePrice: null as null | string,
          reserveNetPrice: null as null | string,
          storageArea: null as null | string,
          tvaRate: null as null | string,
          description: null as null | string,
          appendDescriptionText: null as null | string,
          expertId: null as null | string,
          apporteurId: null as null | string,
        },
        deleteWeaponBook: false,
        deleteItemNumber: false,
        deleteItemSubNumber: false,
        deleteVehicule: false,
        deletePolicebook: false,
        deleteAdagp: false,
        deleteRubrique: false,
        deleteHighlight: false,
        deleteSale: false,
        deleteDateIn: false,
        deleteDateOut: false,
        deleteStorageArea: false,
        deleteEstimationLow: false,
        deleteEstimationHigh: false,
        deleteStartingPrice: false,
        deleteReservePrice: false,
        deleteReserveNetPrice: false,
        deleteTvaRate: false,
        deleteDescription: false,
        deleteExpert: false,
        deleteApporteur: false,
        rubriques: [] as Rubrique[],
        sales: [] as Record<string, string | null>[],
        stockStatuses,
        vatRates: [] as Rate[],
        experts: [] as Record<string, string | null>[],
        apporteurs: [] as Record<string, string | null>[],
        addons: 0,
      }
    },
    computed: {
      ...mapState(['user']),
      userRestriction(): boolean {
        return this.user?.roles.includes('RESTRICTION_USER')
      },
    },
    watch: {
      itemToEdit(newVal) {
        if (newVal) {
          this.formModel = {
            ...newVal,
          }

          if (!this.displayField) {
            this.$nextTick(() => {
              document.getElementById('itemNumberInput')?.focus()
            })
          }
        }
      },
    },
    mounted() {
      if (this.user) {
        this.rubriques = Object.assign([], this.user.client.config.rubriques)
        this.rubriques.push({
          value: null,
          label: 'Pas de changement',
        })
        this.vatRates = this.user.client.structures[0]?.taxRate?.rates ?? []
        this.addons = this.user.client?.addons ?? 0
      }
      if (this.itemToEdit) {
        this.formModel = {
          ...this.itemToEdit,
        }
      }

      this.viewportWidth = window.innerWidth

      window.addEventListener('resize', this.onResize)
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.onResize)
    },
    methods: {
      addonTest(code: number) {
        if (this.addons == null) {
          return true
        }
        return BigInt(code) & BigInt(this.addons)
      },
      onResize() {
        this.viewportWidth = window.innerWidth
      },
      onAppendDescriptionInput(value: string | null) {
        let v: any = value
        if (v && typeof v === 'object' && 'target' in v) {
          v = v.target.value
        }
        const replaced = (this as any).replaceAbbreviations(v)
        if (replaced !== v) {
          this.formModel.appendDescriptionText = replaced
        }
      },
      onFormDescriptionInput(value: string | null) {
        let v: any = value
        if (v && typeof v === 'object' && 'target' in v) {
          v = v.target.value
        }
        const replaced = (this as any).replaceAbbreviations(v)
        if (replaced !== v) {
          this.formModel.description = replaced
        }
      },
      closeModal(updateCheckboxValue = true) {
        this.formModel = {
          weaponBook: null,
          vehicule: null,
          policeBook: null,
          adagp: null,
          rubriqueKey: [null],
          highlight: null,
          sale: null,
          stockStatus: null as null | string,
          dateIn: null as null | string,
          dateOut: null as null | string,
          storageArea: null as null | string,
          itemNumber: null as null | string,
          itemSubNumber: null as null | string,
          estimationLow: null as null | string,
          estimationHigh: null as null | string,
          reservePrice: null as null | string,
          reserveNetPrice: null as null | string,
          startingPrice: null as null | string,
          tvaRate: null as null | string,
          description: null as null | string,
          appendDescriptionText: null as null | string,
          expertId: null as null | string,
          apporteurId: null as null | string,
        }

        this.sales = []

        this.deleteWeaponBook = false
        this.deleteVehicule = false
        this.deletePolicebook = false
        this.deleteAdagp = false
        this.deleteRubrique = false
        this.deleteHighlight = false
        this.deleteSale = false
        this.deleteDateIn = false
        this.deleteDateOut = false
        this.deleteItemNumber = false
        this.deleteItemSubNumber = false
        this.deleteEstimationLow = false
        this.deleteEstimationHigh = false
        this.deleteStartingPrice = false
        this.deleteReservePrice = false
        this.deleteReserveNetPrice = false
        this.deleteStorageArea = false
        this.deleteTvaRate = false
        this.deleteDescription = false
        this.deleteExpert = false
        this.deleteApporteur = false

        this.$emit('closeEditModal', updateCheckboxValue)
      },
      submit() {
        let data = {
          ...this.formModel,
        }
/*
        // Client-side: if appendDescriptionText provided and description not being deleted, append it
        const appendText = (this.formModel as any).appendDescriptionText
        if (appendText && appendText !== '' && this.deleteDescription !== true) {
          const current = this.formModel.description ?? ''
          ;(data as any).description = (current && String(current).trim() !== '' ? current + '\n\n' + appendText : appendText)
        }
*/
        if (this.deleteWeaponBook == true) {
          data.weaponBook = 'NULL'
        }

        if (this.deleteVehicule == true) {
          data.vehicule = 'NULL'
        }

        if (this.deletePolicebook == true) {
          data.policeBook = 'NULL'
        }

        if (this.deleteAdagp == true) {
          data.adagp = 'NULL'
        }

        if (this.deleteRubrique == true) {
          data.rubriqueKey = 'NULL'
        } else {
          if (Array.isArray(this.formModel.rubriqueKey)) {
            data.rubriqueKey = this.formModel.rubriqueKey[this.formModel.rubriqueKey.length - 1]
          } else {
            data.rubriqueKey = this.formModel.rubriqueKey
          }
        }

        if (this.deleteDateIn == true) {
          data.dateIn = 'NULL'
        }

        if (this.deleteDateOut == true) {
          data.dateOut = 'NULL'
        }

        if (this.deleteHighlight == true) {
          data.highlight = 'NULL'
        }

        if (this.deleteSale == true) {
          data.sale = 'NULL'
        }

        if (this.deleteItemNumber == true) {
          data.itemNumber = 'NULL'
        }

        if (this.deleteItemSubNumber == true) {
          data.itemSubNumber = 'NULL'
        }

        if (this.deleteStorageArea == true) {
          data.storageArea = 'NULL'
        }

        if (this.deleteDescription == true) {
          data.description = 'NULL'
        }

        if (this.deleteStartingPrice == true) {
          data.startingPrice = 'NULL'
        }

        if (this.deleteReservePrice == true) {
          data.reservePrice = 'NULL'
        }

        if (this.deleteReserveNetPrice == true) {
          data.reserveNetPrice = 'NULL'
        }

        if (this.deleteEstimationLow == true) {
          data.estimationLow = 'NULL'
        }

        if (this.deleteEstimationHigh == true) {
          data.estimationHigh = 'NULL'
        }

        if (this.deleteExpert == true) {
          data.expertId = 'NULL'
        }

        if (this.deleteApporteur == true) {
          data.apporteurId = 'NULL'
        }

        // Accès concurrents
        // En mode édition d'un item unique : ne transmettre que les champs modifiés.
        if (this.itemToEdit) {
          for (const field of Object.keys(data)) {
            if ((data as any)[field] === 'NULL') continue // suppression explicite, on garde
            let origVal = (this.itemToEdit as any)[field]
            if (field === 'rubriqueKey' && Array.isArray(origVal)) {
              origVal = origVal[origVal.length - 1]
            }
            if (JSON.stringify(origVal) === JSON.stringify((data as any)[field])) {
              delete (data as any)[field] // inchangé → on n'envoie pas le champ
            }
          }
        }

        const params = {
          ...this.query,
          items: this.editPrice ? [this.itemToEdit.id] : this.items,
          data,
        }
        if (this.contact) {
          params.contactId = this.contact
        }
        if (this.page === 'saleItemsList') {
          params.saleId = this.saleId
        }

        this.busy = true
        this.$api
          .put(`/requisitionitems/edit`, params)
          .then((response) => {
            const apiResponse = response.data as ApiResponse

            if (apiResponse.data.pagination) {
              this.$emit('updateItems', apiResponse.data.items)
              this.$emit('setPaginationData', apiResponse.data.pagination)
            } else {
              this.$emit('updateItems', apiResponse.data)
            }

            if (apiResponse.data.length > 0) {
              this.$notify({
                type: 'success',
                title: 'Succès',
                message: 'Opération réalisée avec succès !',
              })
            }

            this.closeModal()
          })
          .catch(() => {
            this.$notify({
              type: 'error',
              title: 'Erreur',
              message: 'Une erreur est survenue. Veuillez nous excuser pour la gêne occasionnée.',
            })
          })
          .finally(() => {
            this.busy = false
            if (this.page === 'boughtItems' || this.page === 'stockItemsList') {
              this.$emit('uncheckAll')
            }
          })
      },
      loadSales(isVisible: boolean) {
        if (isVisible) {
          this.sales = []

          this.$api.get('/sales?type=simple').then((response) => {
            const apiResponse = response.data as ApiResponse

            apiResponse.data.forEach((sale: Sale) => {
              if (sale.status && sale.status !== 'comptabilise') {
                this.sales.push({
                  label: this.getSaleTitle(sale),
                  value: sale?.id?.toString() ?? null,
                })
              }
            })
          })
        }
      },
      loadExperts(isVisible: boolean) {
        if (isVisible) this.experts = this.searchContacts('*', ['commissaire_justice', 'expert'])
      },
      loadApporteurs(isVisible: boolean) {
        if (isVisible) this.apporteurs = this.searchContacts('*', ['apporteur'])
      },
      searchContacts(
        search?: string,
        category = null as string[] | null,
        minLength = 2
      ): Record<string, string | null>[] {
        if (search == '*' || (search && search.length >= minLength)) {
          if (search == '*') {
            search = ''
          }

          //this.infoPrefill = search

          let contacts = [] as Record<string, string | null>[]
          this.$api
            .get('/contacts', {
              params: {
                search: search ?? null,
                category,
              },
            })
            .then((response) => {
              const apiResponse = response.data as ApiResponse
              if (apiResponse.data && Array.isArray(apiResponse.data)) {
                apiResponse.data.forEach((contact: Contact) => {
                  let contactLabel = contact.formName
                  if (contact.city) {
                    contactLabel = `${contactLabel} - ${contact.city}`
                  }
                  contacts.push({
                    label: contactLabel ?? null,
                    value: contact.id?.toString() ?? null,
                  })
                })
              }
            })
            .finally(() => {
              this.busy = false
            })

          return contacts
        } else {
          return []
        }
      },
      getSaleTitle(sale: Sale): string {
        let saleTitle = ''
        if (sale?.title) {
          saleTitle += ' ' + sale?.title.slice(0, 40)
        }
        if (sale?.startDate) {
          const date = Date.parse(sale?.startDate)
          if (date) {
            saleTitle += ' - ' + new Intl.DateTimeFormat('fr-FR').format(date)
          }
        }
        return saleTitle !== '' ? saleTitle : '-'
      },
      searchExistingStorageArea(queryString: string, cb: CallableFunction) {
        let results = [] as Record<string, string>[]
        const storageAreas = [] as Record<string, string>[]

        this.$api
          .get('/storage-areas')
          .then((response) => {
            const apiResponse = response.data as ApiResponse

            apiResponse.data.forEach((storageArea: string) => {
              storageAreas.push({ value: storageArea })
            })
            results = queryString ? storageAreas.filter(this.createFilter(queryString)) : storageAreas
          })
          .finally(() => {
            cb(results)
          })
      },
      createFilter(queryString: string) {
        return (str: Record<string, string>) => {
          return str.value?.toLowerCase().indexOf(queryString.toLowerCase()) === 0 ?? null
        }
      },
      filterCategory(node: Record<string, string>, keyword: string) {
        return node.label.toLowerCase().includes(keyword.toLowerCase())
      },
      isStatusAllowed(status: string) {
        if (this.user?.roles.includes('RESTRICTION_USER')) {
          if (
            status == 'selling' ||
            status == 'sold' ||
            status == 'removed' ||
            status == 'not_shown' ||
            status == 'given_back' ||
            status == 'amicably_sold' ||
            status == 'unfulfilled'
          ) {
            return false
          }
        }
        return true
      },
      // userRestriction(): boolean {
      //   return this.user?.roles.includes('RESTRICTION_USER')
      // },
    },
  })
